import React from "react";
import { Navigate } from "react-router-dom";
import { FinancialReports } from "../../../components/Admin/FinancialReports";
import { usePermissions } from "../../../hooks";

export function FinancialReportsPage() {
  const { hasPermission } = usePermissions();

  if (!hasPermission("paymentCategory", "read")) {
    return <Navigate to="/admin" replace />;
  }

  return <FinancialReports />;
}
export default FinancialReportsPage;
